import React from 'react'
import Hero from '../../components/hero/Hero'
import {ReactComponent as Image} from '../../assets/proyectosDetail.svg'
import './ProyectosDetails.css'

export default function ProyectosDetails() {
    return (
        <div className="proyectosDetailsWrapper">
             <Hero
                title="Bubbo."
                title2="La nueva plataforma de contenido interactivo."
                sub="Queremos que descubras nuestras capacidades más creativas y técnicas. La creacíon de productos requiere de experiencia, interactividad y lógica."
            />
            <ProyectosDetailsContent/>
            <ProyectosDetailsContent/>
            
        </div>
    )
}


function ProyectosDetailsContent(){
    return(
        <div className="proyectosDetailsContentWrapper">
            <div className="proyectosDetailsContentImg">
                <Image/>
            </div>
            <div className="proyectosDetailsContent">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </div>
        </div>
    )
}